export default __webpack_public_path__ + "static/media/image.esle.5af45da0.png";